import { DeleteCategory, UpdateCategory } from "../../redux/category";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { CategoryForm } from "./CategoryForm";
import { ErrorBanner } from "../../components/banner";
import { IoTrash } from "react-icons/io5";
import { Loading } from "../../components/loader";
import { Section } from "../../components/section";
import { Text } from "../../components/typography";
import styled from "styled-components";

export const CategoryEdit = () => {
  const { error, loading } = useSelector((state) => state.category);
  const dispatch = useDispatch();
  const { state } = useLocation();
  let navigate = useNavigate();

  const onFormSubmit = (values) => {
    if (window.confirm(`Are you sure you want to save your edits?`)) {
      dispatch(UpdateCategory(state.category.id, values));
    }

    if (!loading && !error) {
      setTimeout(() => {
        navigate("/categories");
      }, 500);
    }
  };

  const onDeleteSubmit = () => {
    if (window.confirm(`Are you sure you want to delete this?`)) {
      dispatch(DeleteCategory(state.event));
    }

    if (!loading && !error) {
      setTimeout(() => {
        navigate("/categories");
      }, 500);
    }
  };

  const InitialValues = {
    ...state.category,
  };

  if (loading) {
    return <Loading />;
  }
  return (
    <Section>
      <SubNav>
        <li onClick={onDeleteSubmit}>
          <IoTrash />
          <Text>Delete</Text>
        </li>
      </SubNav>
      {error && <ErrorBanner text={error} />}
      <CategoryForm initialValues={InitialValues} onFormSubmit={onFormSubmit} />
    </Section>
  );
};

const SubNav = styled.nav`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 2rem;

  li {
    margin-left: 1.5rem;
    display: flex;
    align-items: center;
    color: red;

    p {
      margin: 0;
      padding: 0 0 0 0.5rem;
      color: red;
    }

    &:hover {
      cursor: pointer;
    }
  }
`;
